import { render, staticRenderFns } from "./CourseSideNav.vue?vue&type=template&id=2826d10d&scoped=true&"
import script from "./CourseSideNav.vue?vue&type=script&lang=js&"
export * from "./CourseSideNav.vue?vue&type=script&lang=js&"
import style0 from "./CourseSideNav.vue?vue&type=style&index=0&id=2826d10d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2826d10d",
  null
  
)

export default component.exports